module.exports = __webpack_public_path__ + "media/s2Part2Model2.826ce725.mp4";